export default __webpack_public_path__ + "static/media/755.a5857670.png";